<div class="text-center">
    <div class="text-center">
        <h4 class="montserrat-bold text-uppercase text-gray-500 mb-4">Attention</h4>
        We will need 2 working days to get your media approved, please check your dates accordingly
        and fix your plan if needed.
    </div>
</div>
<div class="d-flex align-items-center justify-content-center mt-4">
    <button class="btn btn-md btn-outline-gray-500 mr-3" mat-dialog-close (click)="onCancel()">
        Cancel
    </button>
    <button class="btn btn-md btn-gray-500 mr-3" (click)="navigateToSummary()">
        Proceed Anyways
    </button>
</div>
